module.exports = __webpack_public_path__ + "static/media/webfont.e63fa468.woff";